import { c as _c } from "react/compiler-runtime";
import { ProductOptionInterface } from 'modules/products/types/product-option-interface';
import { useEffect } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { SixDots, TrashIcon } from '@systemeio/ui/icons';
import { FormInput, FieldErrorAndDescription } from '@systemeio/ui';
function Option(t0) {
  const $ = _c(44);
  const {
    option,
    changeOptionName,
    changeOptionValue,
    addEmptyOptionValue,
    deleteOption,
    deleteOptionValue,
    error,
    errorOptionValues
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== changeOptionName) {
    t1 = e => {
      changeOptionName(e);
    };
    $[0] = changeOptionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChangeOptionName = t1;
  let t2;
  if ($[2] !== addEmptyOptionValue || $[3] !== option) {
    t2 = () => {
      addEmptyOptionValue(option);
    };
    $[2] = addEmptyOptionValue;
    $[3] = option;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== t) {
    t4 = t("dashboard.products.options.option_name.title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <label className="text-sm font-medium"><span>{t4}</span></label>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = option.name;
  let t7;
  if ($[10] !== t) {
    t7 = t("dashboard.products.options.option_name.title");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== error || $[13] !== handleChangeOptionName || $[14] !== option.name || $[15] !== t7) {
    t8 = <div className="grow"><FormInput value={t6} placeholder={t7} onChange={handleChangeOptionName} maxLength={256} error={error} /></div>;
    $[12] = error;
    $[13] = handleChangeOptionName;
    $[14] = option.name;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== deleteOption) {
    t9 = <TrashIcon className="hover:fill-danger mt-4 cursor-pointer transition-colors" onClick={deleteOption} />;
    $[17] = deleteOption;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex gap-3">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("dashboard.products.options.option_values.title");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <div className="my-2 ml-7 text-sm font-medium">{t11}</div>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== changeOptionValue || $[27] !== deleteOptionValue || $[28] !== option.optionValues || $[29] !== t) {
    let t14;
    if ($[31] !== changeOptionValue || $[32] !== deleteOptionValue || $[33] !== t) {
      t14 = optionValue => <div className="my-2 flex items-center gap-3" key={optionValue.id}><SixDots /><div className="w-[90%]"><FormInput value={optionValue.value} placeholder={t("dashboard.products.options.add_option_value.title")} onChange={e_0 => changeOptionValue(e_0, optionValue.id)} maxLength={256} /></div>{optionValue.value && <TrashIcon className="hover:fill-danger mt-0 cursor-pointer transition-colors" onClick={e_1 => deleteOptionValue(e_1, optionValue.id)} />}</div>;
      $[31] = changeOptionValue;
      $[32] = deleteOptionValue;
      $[33] = t;
      $[34] = t14;
    } else {
      t14 = $[34];
    }
    t13 = option.optionValues.map(t14);
    $[26] = changeOptionValue;
    $[27] = deleteOptionValue;
    $[28] = option.optionValues;
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[35] !== errorOptionValues) {
    t14 = <FieldErrorAndDescription error={errorOptionValues} />;
    $[35] = errorOptionValues;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <hr className="border-text-secondary -ml-6 -mr-6 mb-2 mt-2 border-t-[1.5px] border-solid opacity-40" />;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t10 || $[39] !== t12 || $[40] !== t13 || $[41] !== t14 || $[42] !== t5) {
    t16 = <div className="my-2">{t5}{t10}{t12}{t13}{t14}{t15}</div>;
    $[38] = t10;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
    $[42] = t5;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
}
export default Option;